export const sharedTypography = () => {
  return {
    fontFamily: 'Lato, Public-Sans',
    h1: {
      fontSize: '57.33px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '72px',
      fontWeight: 700,
    },
    h2: {
      fontSize: '47.78px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '56.14px',
      fontWeight: 700,
    },
    h3: {
      fontSize: '39.81px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '48px',
      fontWeight: 700,
    },
    h4: {
      fontSize: '33.18px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '40px',
      fontWeight: 700,
    },
    h5: {
      fontSize: '27.65px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '32px',
      fontWeight: 700,
    },
    h6: {
      fontSize: '18px',
      fontFamily: 'Public-Sans',
      fontStyle: 'normal',
      lineHeight: '24px',
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '19.2px',
      fontFamily: 'Lato',
      fontStyle: 'normal',
      lineHeight: '24px',
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: '16px',
      fontFamily: 'Lato',
      fontStyle: 'normal',
      lineHeight: '24px',
      fontWeight: 400,
    },
    body1: {
      fontSize: '13.33px',
      fontFamily: 'Lato',
      fontStyle: 'normal',
      lineHeight: '16px',
      fontWeight: 400,
    },
    body2: {
      fontSize: '11.11px',
      fontFamily: 'Lato',
      fontStyle: 'Normal',
      lineHeight: '16px',
      fontWeight: 400,
    },
    button: {
      fontSize: '.875rem',
      fontFamily: 'Lato',
      fontStyle: 'Normal',
      lineHeight: '16px',
      fontWeight: 600,
    },
    caption: {
      fontSize: '13.33px',
      fontFamily: 'Lato',
      fontStyle: 'Normal',
      lineHeight: '16px',
      fontWeight: 400,
    },
    overline: {
      fontSize: '.75rem',
      fontFamily: 'Lato',
      fontStyle: 'Normal',
      lineHeight: '16px',
      fontWeight: 300,
    },
  };
};
